import Promos from 'components/promos/promos';
import styles from '../collection-object-package-page.module.scss';
import type { SanityPromo } from '@metmuseum/types';

export default function ResearchLinksTabPanel({
	promos,
}: ResearchLinksTabPanelProps) {
	return (
		<div className={styles.tabPanelContent}>
			<p className={styles.researchLinksInfo}>
				To conduct research on the collection look at the resources and links
				below.
			</p>
			<Promos promos={promos} />
		</div>
	);
}

interface ResearchLinksTabPanelProps {
	promos: SanityPromo[];
}
